import React, { Fragment, useContext } from "react";
import classnames from "classnames";
import Navigation from "../Navigation/Navigation";
import SecondaryNavigation from "../Navigation/SecondaryNavigation";
import HamburgerNavBar from "../Navigation/HamburgerNavBar";
import { ProjectProvider } from "../../contexts/ProjectContext";
import { RegulationStore } from "../../contexts/RegulationContext";
import { InspectionStore } from "../../contexts/InspectionContext";
import { NotificationStore } from "../../contexts/NotificationsContext";
import { DivisionProvider } from "../../contexts/DivisionContext";
import { useRouteMatch } from "react-router-dom";
import AppContext from "../../contexts/AppContext";
/**
 * Default application layout, provides a sidebar and content area
 *
 * User should be logged in
 */
export interface ISidebarLayoutProps {
  checking: boolean;
}

const SidebarLayout: React.FC<ISidebarLayoutProps> = props => {
  const match = useRouteMatch();
  const root = match.path.split("/")[1];
  const appContext = useContext(AppContext)
  const { panel } = appContext

  return (
    <section className="layout layout--sidebar pure-g">
      <DivisionProvider>
        <ProjectProvider>
          <section className={`sidebar pure-u  ${panel === "close" ? "sidebarShift" : ""}`}>
            <Navigation match={match} {...props} />
          </section>

          {/* sorry for the nested context :( */}

          <RegulationStore>
            <InspectionStore>
              <NotificationStore>
                <section className={`content pure-u ${panel === "close" ? "contentShift" : ""}`}>
                  <HamburgerNavBar match={match} {...props} />
                  <Fragment>
                    <SecondaryNavigation
                      className={classnames({
                        dashboard: root === "dashboard",
                        inspection: root === "inspection",
                      })}
                    />
                    {!props.checking && props.children}
                  </Fragment>
                </section>
              </NotificationStore>
            </InspectionStore>
          </RegulationStore>
        </ProjectProvider>
      </DivisionProvider>
    </section>
  );
};

export default SidebarLayout;

export function withSidebarLayout(Component: any) {
  return ({ children, ...props }: { children: any; checking: any }) => {
    return (
      <SidebarLayout {...props}>
        <Component>{children}</Component>
      </SidebarLayout>
    );
  };
}
